<template>
  <v-app>
    <v-main>
      <v-container class="transaction-pending fill-height">
        <v-row justify="center" align="center" class="fill-height">
          <v-col cols="12" md="6" lg="4">
            <v-card elevation="4" class="pa-8">
              <div class="text-center">
                <v-icon color="warning" size="100" class="mb-6">mdi-clock-outline</v-icon>
                <h2 class="text-h4 font-weight-medium mb-4">
                  {{ $t('global.transaction.pendingTitle') || 'Payment Pending' }}
                </h2>
                <p class="text-body-1 text--secondary mb-8">
                  {{
                    $t('global.transaction.pendingMessage') ||
                    'Your payment is being processed. Please wait a moment.'
                  }}
                </p>
                <v-progress-linear indeterminate color="warning" class="mb-8"></v-progress-linear>
                <v-btn outlined large block @click="goToDashboard">
                  <v-icon left>mdi-arrow-left</v-icon>
                  {{
                    deviceId
                      ? $t('global.transaction.returnToDevice')
                      : $t('global.transaction.goToDashboard')
                  }}
                </v-btn>
              </div>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
export default {
  name: 'TransactionPending',
  data() {
    return {
      deviceId: null,
    }
  },
  mounted() {
    const transactionId = this.$route.query.transId
    this.deviceId = this.$route.query.deviceId

    if (!transactionId) {
      console.warn('No transactionId found in route params')
    }
    // Payment is pending
    console.log('Payment pending for transaction:', transactionId)
  },
  methods: {
    goToDashboard() {
      if (this.deviceId) {
        // Encode the device ID in Relay format (Base64 of "Device:id")
        const encodedDeviceId = btoa(`Device:${this.deviceId}`)
        const baseUrl = window.location.origin
        window.location.href = `${baseUrl}/app/device/${encodedDeviceId}`
      } else {
        const baseUrl = window.location.origin
        window.location.href = `${baseUrl}/app`
      }
    },
  },
}
</script>

<style lang="less" scoped>
.transaction-pending {
  background-color: #f5f5f5;
}
</style>
